import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@material-ui/core';

import CompletionRecord from '../../../../model/CompletionRecord';
import ServiceAPI from '../../../../service/ServiceAPI';

const EditDialog = (props) => {
  const [newDescription, setNewDescription] = useState(null);

  /**
   * 
   * @param {*} e 
   */
  const handleChange_newDescription = (e) => {
    setNewDescription(e.target.value);
  }

  /**
   * 
   */
  const handleClick_update = () => {
    let update = new CompletionRecord();
    update.setId(props.record.getCompletionRecordId());
    update.setInventoryId(props.record.getInventoryId());
    update.setDescription(newDescription);
    update.setStarted(props.record.getStarted());
    update.setCompleted(props.record.getCompleted());

    ServiceAPI.CompletionRecord().updateExistingCompletionRecord(update).then((result) => {
      window.location.reload();
      handleClick_close();
    })
  }

  /**
   * 
   */
  const handleClick_close = () => {
    setNewDescription(null);
    props.onClose();
  }

  /**
   * 
   * @returns 
   */
  const render = () => {
    if (props.isOpen === false) {
      return null;
    }

    return (
      <Dialog open={props.isOpen} onClose={handleClick_close} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Edit Description</DialogTitle>
        
        <DialogContent>
          <DialogContentText>
            Provide a new description for the Completion Record
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Description"
            fullWidth
            value={newDescription === null ? props.record.getDescription() : newDescription}
            onChange={handleChange_newDescription}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClick_close} color="primary">
            Cancel
          </Button>
          <Button onClick={handleClick_update} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return render();
}

export default EditDialog;